import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { show } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = ['specialNumber', 'titleLink'];
  static values = {
    articleId: Number,
  };

  connect() {
    if (CurrentUser.isAuthor()) {
      show(this.specialNumberTarget);
    }
  }

  headerClicked(event) {
    if (!event.target.closest('a, button, input') && this.hasTitleLinkTarget) {
      this.titleLinkTarget.click();
    }
  }
}
